import React, { useEffect, useState } from "react";
import { Link }              from "react-router-dom";
import { FiPlus, FiTrash }   from "react-icons/fi";
import axios                 from "axios";
import useTranslations       from "../../hooks/useTranslations";
import useUserLanguage       from "../../hooks/useUserLanguage";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const StatsHeader = () => {
  const [perm, setPerm] = useState({});
  const lang            = useUserLanguage();
  const { translations }= useTranslations(lang);
  const t = (k,d) => translations[k] || d;

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get("/api/admin/my-permissions",
          { headers:{Authorization:`Bearer ${token}` }});
        const p = data.permissions?.find(p=>p.module_key==="static_admin_accounts")||{};
        setPerm(p);
      } catch { setPerm({}); }
    })();
  }, []);

  const canCreate = perm.create_permission || perm.full_access;
  const canTrash  = perm.trash_permission  || perm.full_access;

  return (
    <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
      {canCreate && (
        <Link to="/features/create" className="btn btn-primary">
          <FiPlus size={16} className="me-2" />
          {t("BREADCRUMB_CREATE","Yeni Kayıt")}
        </Link>
      )}

    </div>
  );
};

export default StatsHeader;
